import React, { useState } from "react";
import { useNavigate, useLocation, Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Seo } from "@/components/site/Seo";
import { MotifDivider } from "@/components/site/MotifDivider";
import { toast } from "sonner";

export default function AdminLogin() {
  const { signIn, isAuthed } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  if (isAuthed) return <Navigate to="/admin" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await signIn(email, password);
      toast.success("Welcome back.");
      const to = location.state?.from?.pathname || "/admin";
      navigate(to, { replace: true });
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Invalid email or password");
    } finally {
      setLoading(false);
    }
  };

  const inputStyle = { background: "var(--surface)", borderColor: "var(--card-border)", color: "var(--text)" };

  return (
    <>
      <Seo title="Admin Sign In" path="/admin/login" />
      <div className="flex min-h-screen items-center justify-center p-4" style={{ background: "var(--bg)" }}>
        <div className="w-full max-w-sm">
          <div className="flex flex-col items-center">
            <img src="/brand/logo-icon.webp" alt="Acharya Holdings" className="h-14 w-14 object-contain" />
            <h1 className="mt-5 text-xl font-semibold" style={{ color: "var(--text)" }}>Acharya Holdings</h1>
            <p className="mt-1 text-sm" style={{ color: "var(--muted)" }}>Content Management</p>
          </div>
          <form onSubmit={onSubmit} className="mt-8 space-y-4 rounded-[16px] border p-6" style={{ background: "var(--surface)", borderColor: "var(--card-border)" }}>
            <div>
              <label className="mb-1.5 block text-xs" style={{ color: "var(--muted)" }}>Email</label>
              <input data-testid="admin-login-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                className="w-full rounded-[10px] border px-3.5 py-2.5 text-sm outline-none" style={inputStyle} autoComplete="username" />
            </div>
            <div>
              <label className="mb-1.5 block text-xs" style={{ color: "var(--muted)" }}>Password</label>
              <input data-testid="admin-login-password-input" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
                className="w-full rounded-[10px] border px-3.5 py-2.5 text-sm outline-none" style={inputStyle} autoComplete="current-password" />
            </div>
            <button type="submit" disabled={loading} data-testid="admin-login-submit-button"
              className="inline-flex w-full items-center justify-center gap-2 rounded-[10px] px-5 py-2.5 text-sm font-medium transition-colors disabled:opacity-60"
              style={{ background: "var(--accent)", color: "var(--accent-fg)" }}>
              {loading && <Loader2 size={15} className="animate-spin" />} Sign In
            </button>
          </form>
          <div className="mt-8"><MotifDivider /></div>
        </div>
      </div>
    </>
  );
}
